import axios from '@/api/config';

const chapterMaterials = {
    addChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/addChapterMaterials`,  data);
    },
    addDefaultChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/addDefaultChapterMaterials`,  data);
    },
    batchAddChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/batchAddChapterMaterials`,  data);
    },
    batchAddDefaultChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/batchAddDefaultChapterMaterials`,  data);
    },
    batchUpdateChapterMaterials(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/batchUpdateChapterMaterials`,  data);
    },
    updateChapterMaterials(data) {
        return axios.put(`${process.env.BASE_URL}/chapterMaterials/updateChapterMaterials`,  data);
    },
    updateDefaultChapterMaterials(data) {
        return axios.put(`${process.env.BASE_URL}/chapterMaterials/updateDefaultChapterMaterials`,  data);
    },
    chapterMaterialsList(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterials/chapterMaterialsList`, { params: data });
    },
    getChapterMaterialsList(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterials/getChapterMaterialsList`, { params: data });
    },
    getChapterMaterialsDetail(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterials/getChapterMaterialsDetail`, { params: data });
    },
    getChapterMaterials(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterials/getChapterMaterials`, { params: data });
    },
    deleteChapterMaterials(data) {
        return axios.delete(`${process.env.BASE_URL}/chapterMaterials/deleteChapterMaterials`, { data: data });
    },
    questionPageList(data) {
        return axios.post(`${process.env.BASE_URL}/chapterMaterials/questionPageList`, data);
    },
    getDefaultChapterMaterials(data) {
        return axios.get(`${process.env.BASE_URL}/chapterMaterials/getDefaultChapterMaterials`, { params: data });
    },
    deleteDefaultChapterMaterials(data) {
        return axios.delete(`${process.env.BASE_URL}/chapterMaterials/deleteDefaultChapterMaterials`, { data: data });
    },
}

export default chapterMaterials;



// WEBPACK FOOTER //
// ./src/api/chapterMaterials.js